import React, { useState } from 'react';
import PageContainer from 'containers/PageContainer';
import { Redirect, useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ResetPasswordView from 'views/ResetPasswordView';
import { Auth } from 'lib/Amplify';
import useMessages from 'hooks/useMessages';
import { setAppBusy } from 'store/actions/system';
import { setAccountId, setEmailVerified, setUser } from 'store/actions/user';
import MessageButton from 'components/messages/MessageButton';

const ResetPasswordContainer = () => {
  const history = useHistory();
  const email = useSelector((state) => state.email);
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const {
    genericFailureMessage,
    passwordResetSuccessMessage,
    sendCodeSuccess,
    clearMessage,
  } = useMessages();
  if (!email) {
    return <Redirect to="/" />;
  }

  const handleSubmit = (code, newPassword) => {
    dispatch(setAppBusy(true));
    clearMessage();
    Auth.forgotPasswordSubmit(email, code, newPassword)
      .then(() => Auth.signIn(email, newPassword))
      .then((res) => {
        dispatch(setUser(res));
        dispatch(setEmailVerified());
        passwordResetSuccessMessage();
        if (res.attributes['custom:accountId']) {
          dispatch(setAccountId(res.attributes['custom:accountId']));
          history.push('/overview');
        } else {
          history.replace('/find_account');
        }
      })
      .catch((err) => {
        switch (err.code) {
          case 'InvalidPasswordException':
            setError({
              password: 'Sorry, that password doesn\'t meet the security requirements. Please try again',
            });
            break;
          case 'CodeMismatchException':
            setError({
              code: 'Your code didn\'t work. It may be entered incorrectly or expired.',
            });
            break;
          default:
            genericFailureMessage();
        }
      })
      .finally(() => {
        dispatch(setAppBusy(false));
      });
  };

  const handleChange = (name) => {
    setError({ ...error, [name]: null });
  };

  function handleResendClick() {
    dispatch(setAppBusy(true));
    clearMessage();
    Auth.forgotPassword(email)
      .then(() => {
        sendCodeSuccess();
      })
      .catch(() => {
        genericFailureMessage(
          <>
            Oops that didn&apos;t work.&nbsp;
            <MessageButton onClick={handleResendClick}>Resend code?</MessageButton>
          </>,
        );
      })
      .finally(() => {
        dispatch(setAppBusy(false));
      });
  }

  return (
    <PageContainer hasBack>
      <ResetPasswordView
        onSubmit={handleSubmit}
        onChange={handleChange}
        onResendClick={handleResendClick}
        minPasswordLength={8}
        email={email}
        error={error}
      />
    </PageContainer>
  );
};

ResetPasswordContainer.displayName = 'ResetPasswordContainer';

export default ResetPasswordContainer;
